import $ from 'jquery';

export const init = ($slider) => {

	$(document)
		.on('click', '.js-link-slide', function(e) {
			e.preventDefault();

			$('body, html').animate({
				scrollTop: $( $(this).attr('href') ).offset().top - $('.header').outerHeight(),
			}, 500);

		});

};
